<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_pop"  width="800">
    <div class="insert_edit_template" style="display:none;">
      <div class="input_style insert_edit_left"  >
        <div class="font_style_set">分配策略:</div>
        <div class="insert_edit_input">
          <Select v-model="shareStyle">
            <Option v-for="(option, index) in shareStyleList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">筛选条件:</div>
        <div class="insert_edit_input">
          <Select v-model="selectedResult" @on-change="changeResult">
            <Option v-for="(option, index) in selectedList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">分配留言数:</div>
        <div class="insert_edit_input">
          <Input v-model="shareMessCount" :disabled="disabled" placeholder="请输入分配留言数"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">员工工号:</div>
        <div class="insert_edit_input" style="width: 40%">
          <Input v-model="seatNumber" placeholder="请输入员工工号" clearable />
        </div>
        <Button type="primary" class="submit_btn" @click="numberSearch()" style="margin-left: 20px;margin-top: 6px;border-radius: 1px;">查询</Button>
      </div>
    </div>
    <div class="fixed_table">
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:10%;">
              <Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox>
            </th>
            <th class="font_style_set" style="width:10%;">序号</th>
            <!-- <th class="font_style_set" style="width:20%;">员工编号</th>
            <th class="font_style_set" style="width:30%;">员工姓名</th>
            <th class="font_style_set" style="width:20%;">员工工号</th> -->
            <th class="font_style_set" style="width:20%;">员工姓名</th>
            <th class="font_style_set" style="width:20%;">员工工号</th>
            <th class="font_style_set" style="width:30%;">员工部门</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" style="height: 300px">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :show-overflow-tooltip='true' :key="index" :id="item.agentNumber" :class="{back_color:(index+1)%2==0}">
            <td  style="width:10%;">
              <CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.agentNumber"></Checkbox></CheckboxGroup>
            </td>
            <td  style="width:10%;">{{index+1}}</td>
            <td  style="width:20%;">{{item.employeeName}}</td>
            <td  style="width:20%;">{{item.agentNumber}}</td>
            <td  style="width:30%;">{{item.deptParentName}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="onSure()">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "MessDistributionPop",
    mixins:[publicFunClass],
    props: {
      showMessDis:Boolean,
      total:Number,
      checkIds:Array,

      agentNumber:String,
      leaveName:String,
      leavePhone:String,
      leaveChannel:String,
      leaveContent:String,
      agentNumberAssign:String,
      isCallBack:String,
      starEndTime:Array,
      queryParam:Object,
    },
    data(){
      return {
        model:false,
        disabled:true,
        checkedAll: false,
        selectedResult:'0',
        selectedList:[{'id':'0','name':'按选中结果'},{'id':'1','name':'按搜索结果'}],
        shareStyle:'0',
        shareStyleList:[{'id':'0','name':'平均分配'},{'id':'1','name':'指定数量分配'}],
        shareValue:'',
        shareMessCount:'0',

        count:0,
        seatNumber:'',
        title:"分配提示",
        singleCheckedList: [],
        infoTableList:[],
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        //checkIds:[],
      }
    },
    methods:{
      //列表复选框全选
      checkedAllList:function(){
        if (this.checkedAll){
          for (let i = 0; i < this.infoTableList.length; i++) {
            let id=this.infoTableList[i].agentNumber;
            this.singleCheckedList.push(id);
          }
          return false;
        }
        this.singleCheckedList=[];
      },
      changeResult:function(){
        if(this.selectedResult=="0"){//按会话留言列表页选中结果
            this.shareMessCount=this.checkIds.length+"";
            this.count=this.checkIds.length;
        }else {                     //按会话留言列表页搜索结果
           this.shareMessCount=this.total+"";
           this.count=this.total;
        }
      },
      cancel:function(){
        this.$emit("closeMessDis",false);
      },
      onSure:function () {
                let that=this;
                let param;
                if(this.selectedResult=="0" && this.checkIds.length==0){//按选择
                    this.$Modal.info({
                      title:'提示',
                      content:"请选择需要分配的留言"
                    });
                    return false;
                }
                if(this.selectedResult=="1" && this.total==0){//按结果
                    this.$Modal.info({
                      title:'提示',
                      content:"当前没有可分配的留言"
                    });
                    return false;
                }
                if(this.singleCheckedList.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"请选择员工"
                    });
                    return false;
                }
                if (this.selectedResult=='0'){//选中结果
                  param={
                      agentNumbers:this.singleCheckedList.toString(),//需要处理取 是勾中的坐席工号
                      ids:this.checkIds.toString(),
                      journalType:"统计报表=>明细报表=>会话留言=>按选中结果分配",
                      menuId:"8_2-10-2",
                      type:this.selectedResult,
                  };
                }else if (this.selectedResult=='1'){//按搜索结果
                  
                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再导入"
                    });
                    return false;
                  }
                  delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];

                  this.$set(this.queryParam, 'journalType', '统计报表=>明细报表=>会话留言=>按搜索结果分配');
                  this.$set(this.queryParam, 'menuId', '8_2-10-2');
                  this.$set(this.queryParam, 'type', this.selectedResult);
                  this.$set(this.queryParam, 'agentNumbers', this.singleCheckedList.toString());//需要处理取 是勾中的坐席工号
                  this.$set(this.queryParam, 'mesresult', this.mesresult);

                  param = this.queryParam;
                }
                this.$http.post("chatLeave/doAssignLeaveMsg.json",param) .then(function (res) {
                      let result=res.data.flag;
                      if(result!="666"){
                        that.$Modal.info({
                          title:'提示',
                          content:res.data.msg
                        });
                        return false;
                      }
                      that.$Message.info(res.data.msg);
                      that.$emit("closeMessDis",true);
                });
      },
      initSearch:function () {
        let that=this;
        let param={
          pageNum:"0",
          pageSize:"0",
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("chatLeave/toChatEmp.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.infoTableList=res.data.obj.list.content;

        })
      },
      numberSearch:function () {
        this.infoTableList = this.infoTableList.filter( item =>
            item.agentNumber.indexOf(this.seatNumber) >-1
        );
        if(this.seatNumber == ""||this.seatNumber ==null){
          this.initSearch();
        }
      }
    },
    watch:{
      showMessDis:function () {
        this.model=this.showMessDis;
        this.shareMessCount=this.checkIds.length+"";
        this.count=this.checkIds.length;
        this.title="分配留言";
        if(this.showMessDis){
          this.selectedResult="0";
          this.shareStyle="0";
          this.employeeCode="";
          this.initSearch();
          this.singleCheckedList=[];
          this.checkedAll=false;
        }
      },
      seatNumber: function(val,oldval){
        if(val == ""||val ==null){
          this.initSearch();
        }
      }

    }
  }
</script>

<style scoped>
  .share_input{
    width: 100%;
    text-align: center;
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/MessDistributionPop.vue